import type { FactoryEdit } from '@indutrust/factory-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Workflow events for uploading a factory logo via
 * `PATCH /factories/{id}/update_logo`.
 *
 * Pattern B (custom workflow).
 *
 * @example
 * const dispatch = injectDispatch(factoryLogoEvents);
 * dispatch.updateLogoRequested({ factoryId: 7, file });
 */
export const factoryLogoEvents = eventGroup({
  source: 'factory.logo',
  events: {
    updateLogoRequested: type<{ factoryId: number; file: File }>(),
    updateLogoSucceeded: type<{ factory: FactoryEdit; factoryId: number }>(),
    updateLogoFailed: type<{ error: string }>(),
  },
});
